import {ResourceChangeset} from "core-app/modules/fields/changeset/resource-changeset";

export class CustomTextChangeset extends ResourceChangeset<{ [key:string]:unknown; }> {

}
